<app-notification-item *ngIf="modalNotification" [opened]="true"
                       [notification]="modalNotification" [showRemove] = "false"></app-notification-item>
<a [routerLink]="['/notifications']" class="cursor-pointer md:hidden block relative -top-1">
  <span *ngIf="notSeenNotificationsCount > 0" class="rounded-full text-center inline-block absolute  -top-2 left-3 text-sm w-[25px] h-[25px] leading-[25px]  bg-primary">{{(notSeenNotificationsCount>9)?'9+':notSeenNotificationsCount}}</span>
  <svg class="text-normal" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_4226_8459)">
      <path d="M24.7998 22.2172V23.322h2.12207V22.2172L3.13273 22.2078L3.13278 22.2078L3.14052 22.2008C3.92905 21.4852 4.61841 20.6675 5.19028 19.7693L5.20927 19.7395L5.22538 19.708C5.86646 18.4544 6.25069 17.0853 6.35554 15.6812L6.35763 15.6533V15.6254L6.35763 11.7831L6.35762 11.7816C6.35389 9.92963 7.02145 8.13903 8.23667 6.74146C9.45188 5.3439 11.1324 4.43409 12.967 4.18053L13.6143 4.09107V3.43759V2.4187C13.6143 2.34223 13.6447 2.2689 13.6987 2.21482C13.7528 2.16075 13.8262 2.13037 13.9026 2.13037C13.9791 2.13037 14.0524 2.16075 14.1065 2.21482C14.1606 2.2689 14.191 2.34223 14.191 2.4187V3.42204V4.08231L14.8459 4.16599C16.6971 4.4025 18.3981 5.30684 19.6295 6.70912C20.8609 8.11139 21.5379 9.91507 21.5332 11.7813V11.7831V15.6254V15.6533L21.5353 15.6812C21.6401 17.0853 22.0244 18.4544 22.6654 19.708L22.6827 19.7417L22.7033 19.7735C23.2852 20.6741 23.9859 21.4921 24.7865 22.2054L24.7892 22.2078L24.7998 22.2172Z" stroke="currentColor" stroke-width="1.5"/>
      <path d="M11.9155 24.8887C11.9837 25.3817 12.228 25.8334 12.6033 26.1603C12.9786 26.4872 13.4595 26.6673 13.9572 26.6673C14.4549 26.6673 14.9358 26.4872 15.3111 26.1603C15.6864 25.8334 15.9307 25.3817 15.9989 24.8887H11.9155Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip0_4226_8459">
        <rect width="28" height="28" fill="currentColor"/>
      </clipPath>
    </defs>
  </svg>
</a>
<div class="md:block hidden">
  <app-dropdown [ignoreInnerClick]="true">
    <div class="dropdown-button">
      <button (click)="onOpen()" [className]="notSeenNotificationsCount > 0?'messages has-unreaded':'messages'">
        <span *ngIf="notSeenNotificationsCount > 0" class="rounded-full inline-block absolute  -top-2 text-sm w-[25px] h-[25px] leading-[25px]  bg-primary">{{(notSeenNotificationsCount>9)?'9+':notSeenNotificationsCount}}</span>
        <svg class="text-normal" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_4226_8459)">
            <path d="M24.7998 22.2172V23.322h2.12207V22.2172L3.13273 22.2078L3.13278 22.2078L3.14052 22.2008C3.92905 21.4852 4.61841 20.6675 5.19028 19.7693L5.20927 19.7395L5.22538 19.708C5.86646 18.4544 6.25069 17.0853 6.35554 15.6812L6.35763 15.6533V15.6254L6.35763 11.7831L6.35762 11.7816C6.35389 9.92963 7.02145 8.13903 8.23667 6.74146C9.45188 5.3439 11.1324 4.43409 12.967 4.18053L13.6143 4.09107V3.43759V2.4187C13.6143 2.34223 13.6447 2.2689 13.6987 2.21482C13.7528 2.16075 13.8262 2.13037 13.9026 2.13037C13.9791 2.13037 14.0524 2.16075 14.1065 2.21482C14.1606 2.2689 14.191 2.34223 14.191 2.4187V3.42204V4.08231L14.8459 4.16599C16.6971 4.4025 18.3981 5.30684 19.6295 6.70912C20.8609 8.11139 21.5379 9.91507 21.5332 11.7813V11.7831V15.6254V15.6533L21.5353 15.6812C21.6401 17.0853 22.0244 18.4544 22.6654 19.708L22.6827 19.7417L22.7033 19.7735C23.2852 20.6741 23.9859 21.4921 24.7865 22.2054L24.7892 22.2078L24.7998 22.2172Z" stroke="currentColor" stroke-width="1.5"/>
            <path d="M11.9155 24.8887C11.9837 25.3817 12.228 25.8334 12.6033 26.1603C12.9786 26.4872 13.4595 26.6673 13.9572 26.6673C14.4549 26.6673 14.9358 26.4872 15.3111 26.1603C15.6864 25.8334 15.9307 25.3817 15.9989 24.8887H11.9155Z" fill="currentColor"/>
          </g>
          <defs>
            <clipPath id="clip0_4226_8459">
              <rect width="28" height="28" fill="currentColor"/>
            </clipPath>
          </defs>
        </svg>
      </button>

    </div>
    <div class="dropdown-options">
      <div class="absolute -left-[400px] top-full z-10 mt-3 w-screen max-w-md overflow-hidden rounded-3xl bg-input shadow-lg ring-1 ring-gray-900/5">
        <div class="scroll-block">

          <div class="notifications-list" *ngIf="notifications.length">
            <app-scrollable-wall
              height="60vh"
              scrollHeight="99%"
              (load)="loadMore()">
              <div class="list-item" *ngFor="let notification of notifications">
                <app-notification-item
                  [notification]="notification" (closeNotifyWidget) = "onClose()"></app-notification-item>

                <div class="w-full border-t border-gray-600"></div>
              </div>
              <app-skeleton-notifications *ngIf="loading"></app-skeleton-notifications>
            </app-scrollable-wall>
          </div>
          <div class="notifications-list" *ngIf="(notifications && !notifications.length) || !notifications">
            <h5 class="text-normal text-center px-2 py-5">
              {{'not_found'| translate}}
            </h5>
          </div>

        </div>
        <div class="grid grid-cols-2 divide-x divide-gray-900/5 bg-card">
          <a (click)="onClose()" [routerLink]="['/notifications']"  class="flex items-center justify-center text-normal gap-x-2.5 p-3 text-sm font-semibold leading-6 hover:bg-card-hover">
            {{'View all'| translate}}
          </a>
          <a (click)="seenAll()"  class="flex items-center justify-center text-normal gap-x-2.5 p-3 text-sm font-semibold leading-6 hover:bg-card-hover">
            {{'Mark All As Read'| translate}}
          </a>
        </div>
      </div>
    </div>
  </app-dropdown>

</div>
